import cx from 'classnames';

import { StyledKeylineDiv, StyledTagLabel } from '../../../../ui/Styled';

import TariffItem from './TariffItem';

const AlternativeTariffs = ({ recommendedTariffs }) => {
  // Don't show the best tariff or the current set tariff
  const alternativeTariffs = recommendedTariffs
    .slice(1)
    .filter((tariff) => tariff?.tariff_combination.tariff_standard_combination_id !== 'current_set_tariff');
  return (
    <>
      <StyledTagLabel.Alternative>Alternative tariffs for you:</StyledTagLabel.Alternative>
      <StyledKeylineDiv.Alternative>
        <p>
          Showing {alternativeTariffs.length} alternative tariffs for you to consider, starting with the tariffs most
          beneficial to you:
        </p>
        {alternativeTariffs.map((tariff, index) => (
          <StyledKeylineDiv.Inner
            key={tariff.tariff_combination.tariff_standard_combination_id}
            className={cx({ 'mb-4': index < alternativeTariffs.length - 1 })}
          >
            <TariffItem tariff={tariff} showSupplier={true} />
          </StyledKeylineDiv.Inner>
        ))}
        {/* Last one should not have mb-4 */}
      </StyledKeylineDiv.Alternative>
    </>
  );
};

export default AlternativeTariffs;
